var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-wrapper"},[_c('basic-container',[_c('data-display')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }